import SEO from '../shared/SEO';
import { useNavigate } from 'react-router-dom';

const OrderFailure = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
    <SEO title="Pago Fallido" />
    <div className="container wrapper mt-5">
      <h1 className="text-center mb-4">Pago Fallido</h1>
      <h5 className="text-center">
        Lo sentimos, su pago no pudo ser procesado.
      </h5>
      <h5 className="text-center">
        Por favor, intente realizar el pago nuevamente o póngase en contacto con soporte.
      </h5>
      <div className="text-center mt-4">
        <button className="btn btn-primary" onClick={handleGoHome}>
          Volver a la página principal
        </button>
      </div>
    </div>
    </>
  );
};

export default OrderFailure;
